import restApiDispatcher from "@/store/utils/api-dispatcher";
import { Complain } from "@/models";

const createComplain = (context, params) =>
  restApiDispatcher(context, {
    resource: Complain,
    storeKey: "complainId",
    loadingKey: "complainLoading",
    action: "createComplain",
    silent: "true",
    params
  });

const putComplainPhoto = (context, params) => {
  restApiDispatcher(context, {
    resource: Complain,
    storeKey: "complainPhoto",
    loadingKey: "complainPhotoLoading",
    action: "postComplainPhoto",
    message: "Your complaint has been sent to TNA",
    params
  });
};
export default {
  createComplain,
  putComplainPhoto
};
